import { Component, OnInit } from "@angular/core";
import { UrlconstantsService } from "../../shared/services/urlconstants.service";
import { CupService } from "../../shared/services/cup.service";
import { EpahafService } from "../epahaf/epahaf.service";
import { Router } from "@angular/router";
import { PqvDashboardService } from "./services/pqvDashboard.services";
import { PageEvent } from "@angular/material/paginator";
@Component({
    selector: "app-pqvdashboard",
    templateUrl: "./pqvdashboard.component.html",
    styleUrl: "./pqvdashboard.component.scss",
    standalone: false
})
export class PqvDashboardComponent implements OnInit {

  searchInput: any;
  selectedSite: any;
  sites: any[];
  public urlConstant: any = this.urlconstantsService.fetchUrl();
  showSpinner = false;
  showView: boolean;
  providers: any[] = [];
  showProviders = false;
  diseasesList: Array<any> = [];
  selectedProviderModel: any;
  pcpDropdownforDCE: boolean = false;
  public sitePlaceHolder: string;
  pcpChanged: boolean;
  selectedProvider: any;
  data = [];
  pcpdetails = [];

  showNoRecords: boolean;
  pdfPcpId: any;
  ismemDetailsAvail: Boolean = false;


  selectedMembers = [];
  isShowOverView = true;
  selectedFiles = [];
  allMemberList = [];
  handleResults(searchObj) {
    this.data = searchObj;
  }

  pageSize = 20; currentPage = 0; pagedMembers = [];

  onPageChange(event: PageEvent) { this.pageSize = event.pageSize; this.currentPage = event.pageIndex; this.updatePagedData(); } updatePagedData() { const start = this.currentPage * this.pageSize; const end = start + this.pageSize; this.pagedMembers = this.selectedMembers.slice(start, end); }
  constructor(

    private cupService: CupService,
    private urlconstantsService: UrlconstantsService,
    private epahafService: EpahafService,
    private router: Router,
    private pqvService: PqvDashboardService
  ) { }

  async ngOnInit() {
    window.scrollTo(0, 0);
    this.getExternalDashboard();
    await this.getPCPProviders();

    const memberDetails = this.pqvService.memberDetails();
    if (memberDetails != null) {
      this.selectedSite = memberDetails.selectedSite;
      this.selectedProviderModel = memberDetails.selectedProvider;
      this.pcpChanged = true;
      this.ismemDetailsAvail = true;
      this.onProvidersSubmit(this.selectedProviderModel);
    } else {
      this.pcpChanged = false;
      this.ismemDetailsAvail = false;
    }
  }

  navigateToPatientDashboard(memberDetails: any) {
    memberDetails.selectedSite = this.selectedSite;
    memberDetails.selectedProvider = this.selectedProviderModel;
    this.pqvService.setMemberDetails(memberDetails);
    this.router.navigate(['/providerportal/patient-dashboard']);
  }


  getExternalDashboard() {
    this.sites = [];
    const username = this.cupService.getUserNameFromJWT();
    const url = this.urlConstant.providerDashboard;
    this.showSpinner = true;
    this.cupService.retrieveData('post', url).subscribe(
      data => {
        if (data != null) {
          if (data.sites && data.sites.length) {
            data.sites.map(element => {
              this.sites.push({
                'id': element.siteUid,
                'value': element.siteName,
                'label': element.siteName
              })
            });
          }
          this.showView = true;
        }
        this.showSpinner = false;
      },
      error => {
        this.showSpinner = false;
      }
    );
  }

  pcpAllSites = [];
  async getPCPProviders() {
    this.providers = [];
    //this.activatedMenu = this.items[0];
    this.showProviders = false;
    const siteDetailURL = this.urlConstant.userSiteProviders
    setTimeout(() => {
      this.showSpinner = true;
    }, 100);
    let checkDuplicates = [];
    try {
      const siteData: any = await
        this.cupService.retrieveData('post', siteDetailURL).toPromise();

      if (siteData && siteData.length) {
        siteData.map(each => {
          if (each.providers && each.providers.length > 0) {
            let providerIds = [];
            each.providers.map(element => {
              if (element.pcp && element.region.indexOf("OBSOLETE") === -1) {
                element.value =
                  element.name +
                  "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" +
                  element.region +
                  "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" + element.address.substring(0, 14);
                element.providerUid = element.id;
                element.id = element.providerId;
                if (!checkDuplicates.includes(element.value)) {
                  checkDuplicates.push(element.value);
                  this.providers.push(element);
                }
                if (!providerIds.includes(element.providerId)) {
                  providerIds.push(element.providerId);
                }
              }
            });
            this.pcpAllSites.push({
              value: { id: each.siteUid, value: each.name },
              uid: providerIds
            });
          }
        });
      } else {
        this.diseasesList = [];
      }
      this.showProviders = true;
      this.showSpinner = false;

    } catch (error) {
      console.log(error)
    }
  }

  setProviders(e) {
    this.selectedSite = e;
    if (e.value === "DCE-CMMI Providers") {
      this.pcpDropdownforDCE = true;
    }
    this.providers = [];
    this.diseasesList = [];
    this.setExternalProviders();
  }

  setExternalProviders() {
    this.providers = [];
    //this.activatedMenu = this.items[0];
    this.showProviders = false;
    const siteDetailURL = this.urlConstant.userSiteGet.replace(
      '{siteUid}',
      this.selectedSite.id
    );
    this.showSpinner = true;
    let checkDuplicates = [];
    this.cupService.retrieveData('get', siteDetailURL).subscribe(
      siteData => {
        if (siteData) {
          //console.log("siteData :",siteData)
          //if (siteData.siteProviderConfig && !(_.isEmpty(siteData.siteProviderConfig))) {
          if (siteData.siteProviderConfig && siteData.siteProviderConfig != null) {
            //  this.providers = siteData.siteProviderConfig;
            siteData.siteProviderConfig.map(element => {
              if (element.neighborhood && element.pcp && element.region.indexOf("OBSOLETE") === -1) {
                element.value =
                  element.name +
                  "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" +
                  element.region +
                  "\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0" + element.address.substring(0, 14);
                element.providerUid = element.id;
                element.id = element.providerId;
                if (!checkDuplicates.includes(element.value)) {
                  checkDuplicates.push(element.value);
                  this.providers.push(element);
                }
              }
            });
            // this.selectedProvider = this.providers[0];
            // this.onProvidersSubmit(this.selectedProvider);
          } else {
            this.diseasesList = [];
          }
        }
        this.showProviders = true;
        this.showSpinner = false;
      },
      error => {
        this.showSpinner = false;
      }
    );
  }

  private getProviderInfoByValue(providerUid) {

    if (this.providers && this.providers.length > 0) {
      return this.providers.find(x => x.value == providerUid);
    }
  }

  public onProvidersSubmit(selectedProvider) {
    this.pcpdetails = [];
    this.pdfPcpId = '';
    this.selectedMembers = [];
    if (selectedProvider != undefined) {
      // if (!this.pcpChanged) {
        //const pcp = _.find(this.pcpAllSites, (each => {
        const pcp: any = this.pcpAllSites.find((each => {
          if (each.uid.includes(selectedProvider.id)) {
            return each;
          }
        }));
        if (pcp) {
          this.selectedSite = pcp.value
        }
        else {
          this.selectedSite = undefined;
        }
      // }
      let provider = this.getProviderInfoByValue(selectedProvider.value);
      this.selectedProvider = provider;
      this.getMemberDetails(provider.id)

    }
  }
  getMemberDetails(providerId) {
    if (this.ismemDetailsAvail) {
      this.showSpinner = false;
      this.ismemDetailsAvail = false;
    } else {
      this.showSpinner = true;
    }
    let name = this.cupService.getUserNameFromJWT();
    this.epahafService.getEligibilityDetails(name).subscribe(
      (response) => {
        this.showSpinner = false;
        this.selectedMembers = response.filter(eachMember => eachMember.PRPR_ID == providerId);
        this.allMemberList = this.selectedMembers;
        this.updatePagedData();
      },
      (err) => {
        this.showSpinner = false;

      }
    );
  }
  onSearchMember(e) {
    let value = this.searchInput.trim().toLowerCase();
    if (!value) {
      this.selectedMembers = this.allMemberList;
      this.updatePagedData();

      return;
    } else {
      this.selectedMembers = this.allMemberList.filter(mem => {
        // Search by Member ID or Name (existing functionality)
        const memberIdMatch = mem.memberHmoID.toLowerCase().includes(value);
        const memberNameMatch = mem.member_NAME.toLowerCase().includes(value);
        
        // Search by DOB - handle both input formats
        let dobMatch = false;
        if (mem.memberDOB) {
          // Convert JSON DOB (yyyy-mm-dd) to display format (mm/dd/yyyy) for comparison
          const dobDate = new Date(mem.memberDOB);
          if (!isNaN(dobDate.getTime())) {
            const formattedDOB = (dobDate.getMonth() + 1).toString().padStart(2, '0') + '/' + 
                                dobDate.getDate().toString().padStart(2, '0') + '/' + 
                                dobDate.getFullYear();
            dobMatch = formattedDOB.includes(value);
          }
          //debugger;
          // Also check if the search value matches the original format (yyyy-mm-dd)
          if (!dobMatch) {
            dobMatch = mem.memberDOB.toLowerCase().includes(value);
          }
        }
        
        return memberIdMatch || memberNameMatch || dobMatch;
      });
      this.currentPage = 0;
      const start = this.currentPage * this.pageSize;
      const end = start + this.pageSize;
      this.pagedMembers = this.selectedMembers.slice(start, end);
      this.updatePagedData();

    }

  }



}